export class JobStartedEvent {
  public readonly reviewId: number;
  public readonly reviewItemId: number;
  public readonly operation: string;

  constructor(reviewId: number, reviewItemId: number, operation: string) {
    this.reviewId = reviewId;
    this.reviewItemId = reviewItemId;
    this.operation = operation;
  }
}
